// extracted by mini-css-extract-plugin
export default {"with-docs-column-wrapper":"styles_with-docs-column-wrapper__u9-kM","main-column":"styles_main-column__-3X6v","docs-column":"styles_docs-column__DFBBg"};